import {
  Shader,
  Liquify,
  MultiPointGradient,
  Paper,
  WaveDistortion,
} from 'shaders/react'

export function ShaderEffect({ className }: { className?: string }) {
  return (
    <Shader className={className}>
      <MultiPointGradient
        colorA="#0d0d0d"
        colorB="#341545"
        colorC="#0c4378"
        colorD="#4d363f"
        colorE="#403a08"
        positionA={{
          x: 0.24,
          y: 0.08
        }}
        positionC={{
          x: 0.07,
          y: 0.65
        }}
        positionD={{
          x: 0.9,
          y: 0.7
        }}
        positionE={{
          x: 0.42,
          y: 1
        }}
        visible={true} />
      <WaveDistortion
        angle={78}
        frequency={1.6}
        strength={0.25}
        visible={true}
        waveType="triangle" />
      <Liquify
        damping={0.7}
        radius={1.5}
        stiffness={15} />
      <Paper
        displacement={1}
        grainScale={0.1}
        roughness={0.1}
        seed={26} />
    </Shader>
  )
}
